// assets/datalayer.collectionProductCardEventsConfig.js
export const collectionProductCardEventsConfig = {
    parentSelector: '.main-collection-product-grid-section #product-grid', // Scope to product grid within the collection section
    events: {
        // Collection | click on product card (CSV Line 31 - adapted)
        productCardClick: {
            selector: 'a.full-unstyled-link', // Targets the main link wrapping the card content
            event: {
                event: 'collection', // Event name for collection context
                component: 'product_card',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const cardWrapper = element.closest('.card-wrapper');
                    if (!cardWrapper) return null;

                    // Prevent firing if click is on ATC or Quick View inside the card link area
                    if (element.closest('.quick-add__submit, .quick-view__submit')) return null;

                    const productName = cardWrapper.querySelector('.card__heading a')?.textContent.trim();
                    const vendor = cardWrapper.querySelector('.card__vendor')?.textContent.trim();
                    const priceElement = cardWrapper.querySelector('.price-item--regular');
                    const price = priceElement?.textContent.trim().replace(/[^0-9.,]+/g, '').replace(',', '.') || '0'; // Extract numeric price
                    const productId = cardWrapper.querySelector('input[name="product-id"]')?.value; // Get product ID if available

                    return {
                        product_name: productName || 'Unknown Product',
                        product_id: productId || 'Unknown ID',
                        brand: vendor || 'Unknown Brand',
                        price: parseFloat(price),
                        link_url: element.href
                    };
                }
            }
        },

        // Collection | click on quick view button (CSV Line 31 Addon)
        productQuickViewClick: {
            selector: 'button.quick-view__submit',
            event: {
                event: 'collection',
                component: 'product_card',
                element: 'quick_view', // Specific element
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    const cardWrapper = element.closest('.card-wrapper');
                    if (!cardWrapper) return null;
                    const productName = cardWrapper.querySelector('.card__heading a')?.textContent.trim();
                    return {
                        product_name: productName || 'Unknown Product'
                    };
                }
            }
        },

        // Collection | click on cta button (Add to Cart) (CSV Line 32 - adapted)
        productCardATC: {
            selector: 'button.quick-add__submit',
            event: {
                event: 'collection',
                component: 'product_card',
                element: 'cta_button',
                action: 'click',
                action_value: 'add_to_cart', // Explicit value
                trigger: 'click',
                getDynamicData: (element) => {
                     const cardWrapper = element.closest('.card-wrapper');
                    if (!cardWrapper) return null;

                    const productName = cardWrapper.querySelector('.card__heading a')?.textContent.trim();
                    const vendor = cardWrapper.querySelector('.card__vendor')?.textContent.trim();
                    const priceElement = cardWrapper.querySelector('.price-item--regular');
                    const price = priceElement?.textContent.trim().replace(/[^0-9.,]+/g, '').replace(',', '.') || '0';
                    const productId = cardWrapper.querySelector('input[name="product-id"]')?.value;
                    const buttonText = element.querySelector('span:not(.hidden)')?.textContent.trim() || element.getAttribute('aria-label') || 'Add to cart'; // Get visible text or aria-label

                    return {
                        product_name: productName || 'Unknown Product',
                        product_id: productId || 'Unknown ID',
                        brand: vendor || 'Unknown Brand',
                        price: parseFloat(price),
                        click_text: buttonText
                    };
                }
            }
        }
    }
}; 